import { FC } from 'react';

import { HelpText, HelpChapterProps, useConfigSlice, useTranslation } from '@pp/core';
import styles from './HelpChapters.module.css';
export const HelpChapterBetsAndPayouts: FC<HelpChapterProps> = ({ content }) => {
  const { translations } = useTranslation();
  if (!content) return null;
  const tableNameKey = useConfigSlice.tableConfig()?.tableName ?? '';
  const tableName = translations[tableNameKey] || tableNameKey;

  return (
    <div>
      <p>
        <HelpText>{String(content.placingBets)}</HelpText>
      </p>
      <p>
        <HelpText dynamicValues={{ TABLE_NAME: `${tableName}` }}>{String(content.offeredPayouts)}</HelpText>
      </p>
      <table className={styles.table__help_bet_payout}>
        <thead>
          <tr>
            <th>{String(content.symbol)}</th>
            <th>{String(content.payoutTitle)}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{String(content.symbolOne)}</td>
            <td>{String(content.symbolOnePayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolTwo)}</td>
            <td>{String(content.symbolTwoPayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolFive)}</td>
            <td>{String(content.symbolFivePayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolEight)}</td>
            <td>{String(content.symbolEightPayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolTen)}</td>
            <td>{String(content.symbolTenPayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolFifteen)}</td>
            <td>{String(content.symbolFifteenPayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolTwenty)}</td>
            <td>{String(content.symbolTwentyPayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolThirty)}</td>
            <td>{String(content.symbolThirtyPayout)}</td>
          </tr>
          <tr>
            <td>{String(content.symbolFourty)}</td>
            <td>{String(content.symbolFourtyPayout)}</td>
          </tr>
        </tbody>
      </table>

      <p>
        <HelpText>{String(content.winningSegments)}</HelpText>
      </p>
    </div>
  );
};
